import FeaturedArticleDesktop from '@/components/FeaturedArticle/_components/Desktop/FeaturedArticleDesktop';
import FeaturedArticleMobile from '@/components/FeaturedArticle/_components/Mobile/FeaturedArticleMobile';
import { useData } from '@/shared/providers/DataProvider';
import { useBreakpoints } from '@/shared/providers/Device';
import { MockFeaturedArticle } from '@/shared/types/mocks/mockArticle';
import { FeaturedArticleStoryblok } from '@/shared/types/storyblok/storyblok-types';
import * as Sentry from '@sentry/nextjs';
import { getStoryblokApi } from '@storyblok/react';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const AuthorArticles = ({ author, featuredArticleButton }: { author: string; featuredArticleButton: string }) => {
    const [data, setData] = useState<any>(MockFeaturedArticle);
    const storyblokApi = getStoryblokApi();
    const { isXXSmall, isExtraSmall, isSmall, isMedium } = useBreakpoints();
    const isMobile = isXXSmall || isExtraSmall || isSmall || isMedium;
    const { version } = useData();
    const router = useRouter();

    const fetchStories = async () => {
        const cv = Date.now();
        try {
            const blogResponse = await storyblokApi.get('cdn/stories', {
                version: version,
                language: router.locale,
                cv: cv,
                starts_with: 'blog/',
                resolve_relations: 'article.author',
                filter_query: {
                    author: {
                        is: 'not_empty',
                    },
                },
                per_page: 100,
            });

            const projectResponse = await storyblokApi.get('cdn/stories', {
                version: version,
                language: router.locale,
                cv: cv,
                starts_with: 'projects/',
                resolve_relations: ['project.author', 'project.coAuthors'],
                filter_query: {
                    author: {
                        is: 'not_empty',
                    },
                },
                per_page: 100,
            });
            let allStories = [...blogResponse.data.stories, ...projectResponse.data.stories];

            let filteredContent = allStories.filter((story: any) => {
                if (story.content && story.content.author && story.content.author.content) {
                    if (story.content.author.content._uid === author) {
                        return true;
                    }

                    if (story.full_slug.startsWith('project/') && story.content.coAuthors) {
                        return story.content.coAuthors.some(
                            (coAuthor: any) => coAuthor.content && coAuthor.content._uid === author,
                        );
                    }
                }
                return false;
            });

            setData(filteredContent);
        } catch (error) {
            Sentry.captureException('error in fetch stories', {
                tags: {
                    component: 'author articles',
                },
                level: 'error',
            });
        }
    };

    useEffect(() => {
        fetchStories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FeaturedArticleObject = {
        blok: {
            articleItems: data,
            buttonText: featuredArticleButton,
            arrow: false,
            _uid: '',
            component: 'featuredArticle',
        },
    } as any as FeaturedArticleStoryblok;

    return (
        <div>
            {FeaturedArticleObject?.blok?.articleItems?.length >= 1 && isMobile && (
                <FeaturedArticleMobile {...FeaturedArticleObject} />
            )}
            {FeaturedArticleObject?.blok?.articleItems?.length >= 1 && !isMobile && (
                <FeaturedArticleDesktop {...FeaturedArticleObject} />
            )}
        </div>
    );
};

export default AuthorArticles;
